<h2 mat-dialog-title>{{ 'admin_single_itin.dialog.title' | translate }}</h2>
<p>{{ 'admin_single_itin.dialog.descr' | translate: {itin_name: data.itin_name[data.current_lang]} }}</p>
<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button (click)="onNoClick()">{{ 'admin_single_itin.dialog.cancel' | translate }}</button>
    <button mat-button (click)="deleteItin()" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_itin.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>